<template>
  <el-row type="flex" class="mb-3 static-text">
    <div class="label-column">
      {{ $label }}
    </div>
    <div class="value-column">{{ $value }}</div>
  </el-row>
</template>

<script>
import get from 'lodash/get';
import isObject from 'lodash/isObject';

export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    value: null,
    valuePath: {
      type: String,
      default: null,
    },
    separator: {
      type: String,
      default: ':',
    },
  },
  computed: {
    $label() {
      if (this.label && this.label.length) {
        return this.label + this.separator;
      }
      return '';
    },
    $value() {
      if (this.valuePath === null) {
        return this.value;
      } if (isObject(this.value)) {
        return get(this.value, this.valuePath, null);
      }
      return undefined;
    },
  },
};

</script>

<style lang="scss">

.static-text {
  font-size: 0.9em;

  .label-column {
    color: #999;
  }

  .value-column {
    margin-left: 5px;
    white-space: pre;
  }
}


</style>
